"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
/**
 * 사용자 세션(로그아웃) 관리
 */
var ApiUserSession = /** @class */ (function (_super) {
    __extends(ApiUserSession, _super);
    function ApiUserSession() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.UPDATE_SYNC = "/api/sync/batchSyncAll";
        _this.updateSync = function (accesstoken) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.UPDATE_SYNC,
            });
        };
        return _this;
    }
    ApiUserSession.getInstance = function (initValue) {
        if (!ApiUserSession.classInstance) {
            this.classInstance = new ApiUserSession(initValue);
        }
        return this.classInstance;
    };
    ApiUserSession.prototype.addUserSessionController = function (errorCallback) {
        this.managerInterceptor(errorCallback);
    };
    return ApiUserSession;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiUserSession;
